import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { UseQueryOptions, useQuery } from 'react-query'
import { BrandPlanSchedule } from 'types'
import { scheduleKeys } from './scheduleKeys'

type Data = BrandPlanSchedule[]

export interface Options extends UseQueryOptions<Data> {}

export const fetchPendingBrandPlanSchedules = async ({ workspaceId }: { workspaceId: number }) => {
  const res = await sendToApi<{ schedules: BrandPlanSchedule[] }>(`/w/${workspaceId}/brand_plan_schedules/pending`)
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
  return res.data.schedules
}

export const usePendingBrandPlanSchedules = (options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery<Data>(scheduleKeys.pending(workspaceId), () => fetchPendingBrandPlanSchedules({ workspaceId }), {
    // Enable refetch on window focus to prevent stale data in case user leaves and returns to app
    // Disable in test environment to prevent flaky tests
    refetchOnWindowFocus: process.env.NODE_ENV === 'test' ? false : true,
    // Set staleTime to 0 in tests so refetchInterval updates cache properly, otherwise 30 seconds
    staleTime: process.env.NODE_ENV === 'test' ? 0 : 30000,
    ...options,
  })
}
